import { CommandBody, MessageResponse } from "../common/types/apiTypes";
import { Options } from "../common/types/requestOptions";
import { messageApi } from "./api";
import { ApiError } from "./error";

export const commandMsg = async <
  TBody extends CommandBody, // command body type
  TResponse, // response type
>(
  endpoint: string,
  body: TBody,
  { requestId }: Options = {},
): Promise<MessageResponse<TResponse>> => {
  const res = await messageApi.post<MessageResponse<TResponse>>(endpoint, {
    requestId,
    auth: true,
    body,
  });

  if (!res.data.success) {
    throw new ApiError(res.status, res.data.error || "internal_error");
  }

  return res.data;
};
